import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Overlay');

const propTypes = {
    onClose: PropTypes.func,
    handleBodyClick: PropTypes.func,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            container: PropTypes.string,
            button: PropTypes.string,
            content: PropTypes.string,
            title: PropTypes.string,
        }),
    ]),
    title: PropTypes.string,
    type: PropTypes.string,
    children: PropTypes.node,
};

class Overlay extends PureComponent {
    componentDidMount() {
        const classNameArray = bem('body', 'locked').split(' ');
        document.body.classList.add(...classNameArray);
        this.title?.focus();

        if (this.props.handleBodyClick) {
            document.addEventListener('mousedown', this.handleBodyClick, false);
            document.addEventListener('keydown', this.handleEscKey, false);
            document.addEventListener('touchstart', this.handleBodyClick, false);
        }
    }

    componentWillUnmount() {
        const classNameArray = bem('body', 'locked').split(' ');
        document.body.classList.remove(...classNameArray);
        if (this.props.handleBodyClick) {
            document.removeEventListener('mousedown', this.handleBodyClick, false);
            document.removeEventListener('keydown', this.handleEscKey, false);
            document.removeEventListener('touchstart', this.handleBodyClick, false);
        }
    }

    handleEscKey = (e) => {
        if (e.key === 'Escape') {
            this.props.handleBodyClick();
        }
    };

    handleBodyClick = (e) => {
        if (this.node === null || this.node.contains(e.target)) {
            return;
        } else {
            this.props.handleBodyClick();
        }
    };

    render() {
        const { onClose, className, title, type, children, goBack, borderStyle, overflow, reducedModePosition } = this.props;
        const { container = className, button = null, content = null, title: titleClass = null } = className || '';
        const backModifier = goBack ? 'back' : null;
        return (
            <div className={bem('cover', type)}>
                <div className={bem(null, type, container)} ref={(node) => (this.node = node)}>
                    <div className={bem('header', [title && 'withTitle', borderStyle, titleClass, reducedModePosition])}>
                        {goBack ? <div onClick={(e) => this.props.goBack()} className={bem('back', type)}></div> : null}
                        {title ? (
                            <div className={bem('title', [type, backModifier], titleClass)} aria-label={title} tabIndex="0" ref={(node) => (this.title = node)}>
                                {title}
                            </div>
                        ) : null}
                        {onClose && <button className={bem('close', type, button)} type="button" onClick={onClose} tabIndex="0" aria-label="Close" />}
                    </div>
                    <div className={bem('content', [type, overflow], content)}>{children}</div>
                </div>
            </div>
        );
    }
}

Overlay.propTypes = propTypes;

export default Overlay;
